import styles from './Checkbox.module.scss'

export const Checkbox = ({ value, label, onChange, isChecked, color = '#009be5' }) => {
  return (
    <div className={styles.checkboxContainer}>
      <input
        className={styles.checkboxInput}
        type='checkbox'
        checked={isChecked}
        onChange={onChange}
        value={value}
        style={{ '--checkbox-checked-color': color }}
      />
      <label className={styles.checkboxLabel}>{label}</label>
    </div>
  )
}
